import React from "react";
import AnimatedSection from "../../WebDevelopmentPage/components/AnimatedSection";
import EstimateProjectForm from "../../WebDevelopmentPage/EstimateProjectForm";

const HmsIntroSection: React.FC = () => {
  return (
    <section className="wdev-intro hms-intro" aria-labelledby="hms-intro-title">
      <div className="container">
        <div className="wdev-intro__grid">
          <AnimatedSection className="wdev-intro__content">
            <span className="wdev-label wdev-label--purple">Hospital Management Software</span>
            <h2 id="hms-intro-title" className="wdev-intro__title">
              Hospital Management Software Development Company
            </h2>

            <p className="wdev-intro__text">
              Healthcare industry has always been a crucial one due to its nature — managing even a
              small clinic is a highly tiresome activity with outdated paperwork. As hospitals are
              turning out to be semi-automated, covering some areas like human resource management
              and bill payment, it is now the high time for hospitals to get turned into a
              completely automated system.
            </p>
            <p className="wdev-intro__text">
              Embracing complete systematized automation is the right solution for the current
              chaos faced by the majority of hospital managements in today&apos;s scenario. We
              provide the most enhanced automated hospital management software that helps your
              management work in the most efficient way.
            </p>
            <p className="wdev-intro__text">
              We are the best hospital management software development company in Bangalore, India
              who brings real automation to uplift hospital management systems.
            </p>
          </AnimatedSection>

          <AnimatedSection className="wdev-intro__form-wrap" delay={0.15}>
            <EstimateProjectForm />
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default HmsIntroSection;
